import axios from '../utils/axios';

export function getAllCities() {
  return axios.get('/api/superAdmin/city');
}

export function getFeaturedListsByCity(id) {
  return axios.get(`/api/superAdmin/city/${id}`);
}
